import { render, staticRenderFns } from "./ActivityFrequencyGrowthTrend.vue?vue&type=template&id=5e12dcc5&scoped=true&"
import script from "./ActivityFrequencyGrowthTrend.vue?vue&type=script&lang=js&"
export * from "./ActivityFrequencyGrowthTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e12dcc5",
  null
  
)

export default component.exports